import { Entry } from '../Entry'

export function Entry20220505() {
  return (
    <Entry title="05/05/2022 - v3.0.5">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/12587/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
